// v2后的state都在这里管理，以便过渡到v3

export default {
  namespaced: true,
  state: {
    updateQues: 0, // 更新试题触发
    createQues: 0, // 创建试题触发
    deleteQues: 0, // 删除试题触发
    updateCard: 0, // 更新整张答题卡
    isPartition: false, // 是否触发分区
    isUpdateSubjective: 0, // 是否更新主观题
    isTkAction: false, // 是否是题卡合一、题卡分离操作
    isCreateCard: 0, // 是否触发创建答题卡逻辑
    loginPlatform: sessionStorage.getItem('LoginPlatform') || 'school', // 登录平台：region / school
    changeQuesType: 0, // 是否触发试题类型变更
  },
  mutations: {
    setLoginPlatform: (state, val) => {
      state.loginPlatform = val
      sessionStorage.setItem('LoginPlatform', val || 'school')
    },
    setUpdateQues: (state, val) => {
      state.updateQues = val
    },
    setCreateQues: (state, val) => {
      state.createQues = val
    },
    setDeleteQues: (state, val) => {
      state.deleteQues = val
    },
    setUpdateCard: (state, val) => {
      state.updateCard = val
    },
    setIsPartition: (state, val) => {
      state.isPartition = val
    },
    setIsUpdateSubjective: (state, val) => {
      state.isUpdateSubjective = val
    },
    setIsTkAction: (state, val) => {
      state.isTkAction = val
    },
    setIsCreateCard: (state, val) => {
      state.isCreateCard = val
    },
    setChangeQuesType: (state, val) => {
      state.changeQuesType = val
    },
  },

  getters: {
    /**
     * 判断当前登录平台是否为区域平台
     * @returns {boolean} 如果是区域平台返回true，否则返回false
     */
    isRegion: (state) => {
      return state.loginPlatform === 'region'
    }
  }
}
